import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FileExtension } from '../../../domain/enums/file-extension'
import { useExportRefunds } from '../../hooks/use-export-refunds'

import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@hub-la/shadcn'
import { Download } from 'lucide-react'

export const ExportModal = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [fileExtension, setFileExtension] = useState<FileExtension>(FileExtension.XLSX)

  const { t } = useTranslation()
  const { mutateAsync: exportRefunds, isLoading } = useExportRefunds()

  const handleVisibility = () => setIsOpen(!isOpen)

  const handleExport = async () => {
    await exportRefunds({ fileExtension })
    handleVisibility()
  }

  const isMobile = window.innerWidth < 768

  return (
    <Dialog open={isOpen} onOpenChange={handleVisibility}>
      <DialogTrigger asChild>
        <Button variant="outline" size="default" className={isMobile ? 'w-full' : ''}>
          <Download className="mr-2 h-4 w-4" />
          Exportar
        </Button>
      </DialogTrigger>

      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>{t('export.title')}</DialogTitle>
        </DialogHeader>

        <div className="grid gap-4 py-4">
          <div className="grid grid-cols-4 items-center gap-4">
            <Label htmlFor="fileExtension" className="text-right">
              {t('export.fileExtension')}
            </Label>

            <Select
              disabled={isLoading}
              onValueChange={(value) => setFileExtension(value as FileExtension)}
              value={fileExtension}
            >
              <SelectTrigger className="col-span-3">
                <SelectValue placeholder="Select file type" />
              </SelectTrigger>

              <SelectContent className="z-[100]">
                <SelectItem value={FileExtension.XLSX}>xlsx</SelectItem>
                <SelectItem value={FileExtension.CSV}>csv</SelectItem>
                <SelectItem value={FileExtension.JSON}>json</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>

        <DialogFooter className="flex justify-end gap-4">
          <Button variant="outline" disabled={isLoading} onClick={handleVisibility}>
            {t('export.cancel')}
          </Button>

          <Button onClick={handleExport} disabled={isLoading}>
            {isLoading ? 'Exportando...' : t('export.confirm')}
            <Download className="ml-2 h-4 w-4" />
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
